import React from 'react';
import styles from './LinkToArea.styles';
import { batch, useDispatch, useSelector } from 'react-redux';

import { fetchCircleById } from '../../redux/store/userData/circles';
import { selectSelectedDrawersCount } from '../../redux/store/ui/common';
import { Link } from 'react-router-dom';
import { ExportOutlined } from '@ant-design/icons';

interface Props {
  text?: string;
  circleId?: string;
  params?: any;
}

const LinkToCircle: React.FC<Props> = ({ text, circleId }) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  const onClickHandler = (e: any) => {
    e.preventDefault();
    if (circleId != null && openedDrawersCount < 2) {
      batch(() => {
        dispatch(fetchCircleById(circleId));
      });
    }
  };
  return (
    <>
      {openedDrawersCount < 2 ? (
        <span className="link" onClick={onClickHandler}>
          {text || '-'}
        </span>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=CIRCLE&type=TABLE&pageSize=50&pageNumber=1&circleId=${circleId}`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link">{text}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToCircle;
